import React from "react";
import { C } from "../../theme/tokens";

// Without this, ANY uncaught render/effect error anywhere below it
// unmounts the whole React tree. Since the page background is near
// black (#030407, see index.css / theme/tokens.js C.canvas), the
// result is exactly the "black screen" symptom: no crash message,
// just the bare html background showing through.
//
// This boundary catches that error, logs it to the console (so it's
// visible in Telegram's in-app inspector / remote debugging), and
// shows a small recoverable message instead of a blank screen.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] caught:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            padding: 24,
            textAlign: "center",
            background: C.canvas,
            color: C.primary,
            fontFamily: "'Space Grotesk', sans-serif",
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 700 }}>Сталася помилка</div>
          <div style={{ fontSize: 12, color: C.mutedB, maxWidth: 320 }}>
            {String(this.state.error?.message || this.state.error)}
          </div>
          <button
            type="button"
            onClick={this.handleReset}
            style={{
              marginTop: 8,
              padding: "8px 16px",
              borderRadius: 8,
              border: `1px solid ${C.hairline}`,
              background: C.panel2,
              color: C.primary,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Спробувати ще раз
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
